/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { PropsWithChildren, useEffect, useState } from 'react';

import { TabWrapper } from '../../styled';

export interface TourStickyHeaderProps {
  xl: boolean;
  searchBarRef: any;
  parentRef: any;
}

const TourStickyHeader = ({
  children,
  xl,
  searchBarRef,
  parentRef,
}: PropsWithChildren<TourStickyHeaderProps>) => {
  const [tabsType, setTabsType] = useState('');
  const scrollHandler = () => {
    if (window.scrollY < 225) setTabsType('');
    if (window.scrollY > 225 && !xl) setTabsType('mobile');
    if (window.scrollY > 475 && xl) setTabsType('desktop');
  };
  useEffect(() => {
    window.addEventListener('scroll', scrollHandler, { passive: true });

    () => window.removeEventListener('scroll', scrollHandler);
  }, []);

  return (
    <TabWrapper
      visible={tabsType === 'desktop' || tabsType === 'mobile'}
      top={searchBarRef?.current?.offsetHeight}
      ref={parentRef}
    >
      {children}
    </TabWrapper>
  );
};

export default TourStickyHeader;
